import { memo } from 'react';
import { Flex, Divider, HStack, Box, Text, DataList, DataItem } from '@cad-arc';
import { CommonSize, getOneSizeSmaller } from '../../../../common/helpers/utils';
import { getDataItemText } from '../../../../common/helpers/component-utils';

export const PhoneCallInfo = memo(function PhoneCallInfo({
    callerName,
    callerPhoneNumber,
    classOfServiceText,
    size,
}: {
    callerName?: string;
    callerPhoneNumber?: string;
    classOfServiceText?: string;
    size?: CommonSize;
}): React.ReactElement {
    const smallerSize = getOneSizeSmaller(size);

    return (
        <>
            <Flex direction="column" padding="12px 18px">
                <Box marginBottom={3}>
                    <Text fontSize={size}>Call Info</Text>
                </Box>
                <DataList direction="column" variant="stacked" spacing={3}>
                    <HStack alignItems="flex-start" gap={6}>
                        <DataItem
                            dataKey={<Text fontSize={smallerSize}>Caller Name</Text>}
                            style={{ flexBasis: '50%', wordBreak: 'break-word' }}
                        >
                            {getDataItemText(size, callerName)}
                        </DataItem>
                        <DataItem
                            dataKey={<Text fontSize={smallerSize}>Caller Phone</Text>}
                            style={{ flexBasis: '50%', wordBreak: 'break-word' }}
                        >
                            {getDataItemText(size, callerPhoneNumber)}
                        </DataItem>
                    </HStack>
                    <DataItem
                        dataKey={<Text fontSize={smallerSize}>Class Of Service</Text>}
                        style={{ flexBasis: '50%', wordBreak: 'break-word' }}
                    >
                        {getDataItemText(size, classOfServiceText)}
                    </DataItem>
                </DataList>
            </Flex>
            <Divider />
        </>
    );
});
